var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'table--header',
    'text-cursor',
    { active: _vm.property === _vm.sortProperty },
  ],on:{"click":_vm.setSort}},[_c('span',[_vm._v(_vm._s(_vm.label))]),[(_vm.direction === 'asc')?_c('i',{staticClass:"el-icon-top"}):(_vm.direction === 'des')?_c('i',{staticClass:"el-icon-bottom"}):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }